<dialog-draggable-header>NEC Reports for {{this.tool.toolNo}}</dialog-draggable-header>

<div *ngIf="hasLoaded" class="h-100">
    <div *ngIf="(this.necData$ | async) as data" class="h-100">
        <data-table #necGrid [columns]="columns" [data]="this.necData$ | async" [filterColumnDisplay]="false"
            [loading]="loading" (select)="necLecSelected($event)">
            <ng-container actionStart>
                <button mat-button class="m-1" type="button" (click)="onReportclick()"
                    (keydown.enter)="onReportclick()">
                    Preview/Print/File Report
                </button>
            </ng-container>
            <ng-container actionEnd>
                <button mat-button class="m-1" mat-dialog-close type="button" (keypress)="cancel()"
                    (click)="cancel()">Cancel</button>
            </ng-container>
        </data-table>
    </div>
</div>